var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSipConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 300.5,
    y: 232,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 26.9,
    width: 11.8,
    y: 26.5,
    x: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 11.8,
    width: 52.3,
    y: 34.1,
    x: 25.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    height: 4,
    width: 10.6,
    y: 38,
    x: 14.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m70.8,17.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m39.7,17.7l0,3.9c0,0.4 0.3,0.8 0.6,0.9c3.7,1.4 9.9,2.2 17,2.2c7.1,0 13.3,-0.9 17,-2.2c0.4,-0.1 0.6,-0.5 0.6,-0.9l0,-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m74.3,16.9c-3.7,-1.4 -9.9,-2.2 -17,-2.2c-7.1,0 -13.3,0.9 -17,2.2c-0.3,0.1 -0.6,0.4 -0.6,0.7c0.1,0.3 0.3,0.6 0.6,0.7c3.7,1.4 9.9,2.2 17,2.2c7.1,0 13.3,-0.9 17,-2.2c0.3,-0.1 0.5,-0.4 0.6,-0.7c-0.1,-0.3 -0.3,-0.6 -0.6,-0.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    height: 6.3,
    width: 7.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 86.9239 -27.6473)",
    y: 26.5,
    x: 53.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipConnector);
export default __webpack_public_path__ + "static/media/sipConnector.9fd520734f1acb1c2174073db5fb8bae.svg";
export { ForwardRef as ReactComponent };